export default "__VITE_ASSET__DY7AY4TR__"